export const selectionHeaders = [
    {
        "ordre": 1,
        "champ": "planss_mode_aff",
        "label_champ": "Mode",
        "format_champ": "",
        "affiche_tableau": true,
        "align": "",
        "add_only": false,
        "modif": false
    },
    {
        "ordre": 2,
        "champ": "departement.dept_nom_aff",
        "label_champ": "Departement",
        "format_champ": "",
        "affiche_tableau": true,
        "align": "",
        "add_only": false,
        "modif": false
    },
    {
        "ordre": 3,
        "champ": "categorie.cat_descr_aff",
        "label_champ": "Catégorie",
        "format_champ": "",
        "affiche_tableau": true,
        "align": "",
        "add_only": false,
        "modif": false
    },
    {
        "ordre": 4,
        "champ": "fournisseur.four_nom_aff",
        "label_champ": "Fournisseur",
        "format_champ": "",
        "affiche_tableau": true,
        "align": "",
        "add_only": false,
        "modif": false
    },
    {
        "ordre": 5,
        "champ": "gamme.gamme_descr",
        "label_champ": "Gamme",
        "format_champ": "",
        "affiche_tableau": true,
        "align": "",
        "add_only": false,
        "modif": false
    },


]